import { useState, useRef } from 'react';
import { getToken } from '../utils/auth';
import './UploadPage.css';
import { uploadFile } from "../utils/auth";
import { FiUploadCloud } from "react-icons/fi";
const UploadPage = () => {
  const [file, setFile] = useState(null);
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const [progress, setProgress] = useState(0);
  const inputRef = useRef();

  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
    setMessage('');
    setProgress(0);
  };

  const handleUpload = async () => {
    if (!file) {
      alert('Please select a file.');
      return;
    }

    const formData = new FormData();
    formData.append('file', file);

    setLoading(true);
    setMessage('');
    setProgress(0);

    try {
      const token = getToken();
      const res = await uploadFile(formData, token, (event) => {
        if (event.total) {
          const percent = Math.round((event.loaded * 100) / event.total);
          setProgress(percent);
        }
      });

      const data = res.data;
      if (data?.status === true) {
        setMessage(data.message);
        setFile(null);
        if (inputRef.current) inputRef.current.value = '';
      } else if (data?.status === false) {
        setMessage(data.message);
        setFile(null);
        if (inputRef.current) inputRef.current.value = '';
      }
       else {
        setMessage('Something went wrong');
      }
    } catch (err) {
      console.error(err);
      setMessage('Upload failed: ' + (err.response?.data?.error || err.message));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="upload-workspace">
      <div className="upload-card">
        <div className="upload-card-header">
          <div className="upload-icon">
            <FiUploadCloud aria-hidden="true" />
          </div>
          <div>
            <h2>Upload Excel File</h2>
            <p>Process a campaign workbook and make it available for reporting.</p>
          </div>
        </div>

        <div className="file-input-wrapper">
          <label htmlFor="campaign-file">Excel workbook</label>
          <input
            id="campaign-file"
            ref={inputRef}
            type="file"
            onChange={handleFileChange}
            accept=".xlsx, .xls"
            className="form-control"
          />
          {file && <span className="selected-file">{file.name}</span>}
        </div>

        <button
          type="button"
          onClick={handleUpload}
          disabled={loading}
          className="btn upload-btn"
        >
          {loading ? (
            <>
              <span className="spinner-border spinner-border-sm me-2"></span>
              Uploading
            </>
          ) : (
            "Upload File"
          )}
        </button>

        {loading && (
          <div className="upload-progress-block">
            <div className="progress modern-progress">
              <div
                className="progress-bar"
                style={{ width: `${progress}%` }}
              ></div>
            </div>
            <div className="progress-label">
              {progress}% complete
            </div>
          </div>
        )}

        {message && (
          <div
            className={`result-alert ${
              message.toLowerCase().includes("success") ? "success" : "error"
            }`}
          >
            {message}
          </div>
        )}
      </div>
    </div>
);
};

export default UploadPage;
